/* APIRoutes
* Use create/retrieve/update/delete keywords for api prop name and follow the module screen hierarchy.
* if same api is used for multiple operations, define it once with the prop name in short form
*  (e.g cu, cd,cud, crud)
*/

export const APIRoutes = {
    purchaseOrders: {
        process: {
            purchaseOrders: 'PurchaseOrders/PurchaseOrder/:PurchaseOrder/Process',
            setStatus: 'PurchaseOrders/PurchaseOrder/:PurchaseOrder/Status/:SetStatus',
            actions: {
                retrieve: 'CustomTypes/Lookup/PurchaseProcessOrderAction/Search',
            }
        },
        fastEntry: {
            insert: 'PurchaseOrders/PurchaseOrder/:PurchaseOrder/CreateFastLine',
            calculateFastLine: 'PurchaseOrders/PurchaseOrder/:PurchaseOrder/CalculateFastLine',
        },
        lines: {
            retrieve: 'PurchaseOrders/PurchaseOrder/:PurchaseOrder/OrderLines',
            delete: 'PurchaseOrders/PurchaseOrder/:PurchaseOrder/Line/:LineNumber/Delete',
            calculate: 'PurchaseOrders/PurchaseOrder/:PurchaseOrder/Line/:LineNumber/CalculateGridLine',
            update: 'PurchaseOrders/PurchaseOrder/:PurchaseOrder/Line/:LineNumber/UpdateGridLine',
            details: 'PurchaseOrders/PurchaseOrder/:PurchaseOrder/Line/:LineNumber/Details',
            updateDetails: 'PurchaseOrders/PurchaseOrder/:PurchaseOrder/Line/:LineNumber/UpdateLineDetail',
            calculateDetails: 'PurchaseOrders/PurchaseOrder/:PurchaseOrder/Line/:LineNumber/CalculateLineDetail'
        },
        load: {
            purchaseOrder: 'PurchaseOrders/PurchaseOrder/:PurchaseOrder/Load'
        },
        create: {
            purchaseOrder: 'PurchaseOrders/PurchaseOrder/Create'
        },
        summary: {
            retrieve: 'PurchaseOrders/PurchaseOrder/:PurchaseOrder/Summary',
        },
        details: {
            retrieve: 'PurchaseOrders/PurchaseOrder/:PurchaseOrder/Details',
            calculate: 'PurchaseOrders/PurchaseOrder/:PurchaseOrder/Details',
            update: 'PurchaseOrders/PurchaseOrder/:PurchaseOrder/Details',
        },
        diary: {
            lines: {
                retrieve: 'Diary/GetDiaries/porder/Key/:PurchaseOrder',
                update: 'Diary/:DiaryId',
                delete: 'Diary/:DiaryId',
            },
            detail: {
                retrieve: 'Diary/:DiaryId',
                create: 'Diary/porder/Key/:PurchaseOrder'
            }
        },
        delivery: {
            retrieve: 'PurchaseOrders/PurchaseOrder/:PurchaseOrder/DeliveryDetails',
            calculate: 'PurchaseOrders/PurchaseOrder/:PurchaseOrder/DeliveryDetails',
            update: 'PurchaseOrders/PurchaseOrder/:PurchaseOrder/DeliveryDetails'
        },
        notepad: {
            retrieve: 'Notepad/Table/porder/Key/:PurchaseOrder',
            update: 'Notepad/Table/porder/Key/:PurchaseOrder',
        },
        commit: {
            retrieve: 'PurchaseOrders/PurchaseOrder/:PurchaseOrder/OutstandingLines',
        },
        lineCommitments: {
            retrieve: 'PurchaseOrders/PurchaseOrder/:PurchaseOrder/Line/:LineNumber/OutstandingDocuments',
            update: 'PurchaseOrders/PurchaseOrder/:PurchaseOrder/Line/:LineNumber/UpdateCommitment',
            summary: 'PurchaseOrders/PurchaseOrder/:PurchaseOrder/Line/:LineNumber/CommitLineSummary'
        },
        searchLookup: 'CustomTypes/Lookup/PurchaseOrder/Search'
    }
};
